import { get } from 'svelte/store';
import { _ } from 'svelte-i18n';

import { Location } from '../components/Location/Location';
import { ResolutionDate } from '../components/telematics/components/Colorizer/ResolutionDate';
import { app } from '../../stores/app';
import { features } from './Features/features';
import { debug } from '../../stores/store';

export class BalloonContentGenerator {
    constructor(private job: Location) {}

    public getBalloonHtmlArray(): string[] {
        let alreadyUsedKeys: string[] = [];
        let html = [];

        // // id
        // if (this.job.id !== null && this.job.id >= 0) {
        //     html.push('<div style="opacity:0.5;">#' + this.job.id + '</div>');
        // }

        // ext_id
        html.push(
            '<div style="font-size: 14px; font-weight: bold; margin-bottom: 5px;">' +
                [this.job.getExtId()].filter(s => (s || '').trim()).join(', ') +
                '</div>'
        );

        // address
        if (this.job.getData()?.address_attributes) {
            html.push(
                '<div style="font-size: 14px;">' +
                    [
                        this.job.getData()?.address_attributes?.city || '',
                        (this.job.getData()?.address_attributes?.street || '') +
                            ' ' +
                            (this.job.getData()?.address_attributes?.house || ''),
                    ]
                        .filter(s => (s || '').trim())
                        .join(', ') +
                    '</div>'
            );

            let line2 = [];
            line2.push(this.job.getData()?.address_attributes?.country || 'PL');
            line2.push(this.job.getData()?.address_attributes?.pcode || '');
            line2.push(this.job.getData()?.address_attributes?.province || '');
            line2.push(this.job.getData()?.address_attributes?.community || '');
            html.push(`<div style="margin-bottom: 14px;">
                <div>${line2.filter(w => w !== '').join(', ')}</div>
            </div>`);
            alreadyUsedKeys = ['city', 'street', 'house', 'country', 'pcode', 'province', 'community'];
        }

        alreadyUsedKeys.push('ext_id'); // this field is shown on top
        alreadyUsedKeys.push('full_name'); // this field should be in the file (attributes)
        alreadyUsedKeys.push('location_type'); // this field should be in the file (attributes)

        let sortedAttributes: { key: string; label: string; value: string }[] = [];

        let prefferedKeyOrder = [
            // 'ext_id',
            'target_date',
            'start_of_time_window',
            'end_of_time_window',
            'earliest_delivery_date',
            'latest_delivery_date',
            'delivery_or_collection',
            'parcels',
            'number_of_pallets',
            'total_weight',
            'fill_percentage',
            'unique_delivery_id',
        ];

        let attributes = Object.assign({}, this.job.getData()?.client_attributes, this.job.getData()?.special_attributes);

        if (this.job.getTargetDate() !== null) {
            attributes = Object.assign({}, attributes, { target_date: this.job.getTargetDate() });
        }

        // make unique keys in alreadyUsedKeys
        // alreadyUsedKeys = Array.from(new Set(alreadyUsedKeys));

        Object.keys(attributes ?? {}).forEach(attr => {
            try {
                if (attributes !== null && !alreadyUsedKeys.includes(attr) && attributes[attr] !== null) {
                    let valueStr = attributes[attr].toString() ?? '';
                    if (attr === 'earliest_delivery_date' || attr === 'latest_delivery_date' || attr === 'target_date') {
                        let date = new Date(valueStr);
                        if (!isNaN(date.getTime())) {
                            valueStr = ResolutionDate.getShortFormat(date);
                        }
                    }
                    let label = get(_)(attr);
                    // if (attr === 'ext_id') {
                    //     // https://er.automapa.pl/issues/43462?project=false
                    //     label = get(app).settingsReadonly?.short_name_instead_of_unique_id ? get(_)('ext_id') : get(_)('Unique id');
                    // }
                    if (valueStr !== '') {
                        sortedAttributes.push({
                            key: attr,
                            label: label,
                            value: get(_)(valueStr.replace(/\xf3/g, 'ó')),
                        });
                        alreadyUsedKeys.push(attr);
                    }
                }
            } catch (e) {
                console.warn('BalloonContentGenerator, attributes, cannot convert attr', attr, attributes[attr], e);
            }
        });

        sortedAttributes = sortedAttributes.sort((a, b) => {
            let aIndex = prefferedKeyOrder.indexOf(a.key);
            let bIndex = prefferedKeyOrder.indexOf(b.key);
            if (aIndex === -1) aIndex = 999;
            if (bIndex === -1) bIndex = 999;
            return aIndex - bIndex;
        });

        // sortedAttributes.sort((a,b) => a.label.localeCompare(b.label));

        for (let attr of sortedAttributes) {
            if (get(debug)) {
                html.push('<div><label style="opacity:0.5;">' + attr.key + ': ' + attr.label + ':</label> ' + attr.value + '</div>');
            } else {
                html.push('<div><label style="opacity:0.5;">' + attr.label + ':</label> ' + attr.value + '</div>');
            }
        }
        return html;
    }
}
